import { type FC } from "react";

import type { ApiMagentoConsumablesContentsType } from "@jti/magento-types";
import { I18n } from "@jti/ui/components/I18n";
import { useTranslations } from "@jti/ui/providers/useTranslations";

type ConsumablesQuantityItemTextProps = {
  quantity: number;
  contentsType: ApiMagentoConsumablesContentsType;
  itemsPerPackage: number;
  packagesPerBundle?: number;
};
export const ConsumablesQuantityItemText: FC<ConsumablesQuantityItemTextProps> = ({
  quantity,
  contentsType,
  itemsPerPackage,
  packagesPerBundle,
}) => {
  const { __ } = useTranslations();

  // Added this for backward compatibility. Can be removed if all markets have translations for the pluralised versions
  const hasPluralizetTransaltiosnMainText =
    __(`consumablesForm.step.quantity_selection.button.text.${contentsType}.plural`, [0]) !==
      `consumablesForm.step.quantity_selection.button.text.${contentsType}.plural` &&
    __(`consumablesForm.step.quantity_selection.button.text.${contentsType}.singular`, [1]) !==
      `consumablesForm.step.quantity_selection.button.text.${contentsType}.singular`;

  const secondaryTextQuantity = itemsPerPackage * quantity * (packagesPerBundle ?? 1);
  const secondaryText = __(`consumablesForm.step.quantity_selection.button.text.additional.${contentsType}`, [
    secondaryTextQuantity,
  ]);

  const quantityPluralization = quantity > 1 ? "plural" : "singular";
  const mainTextPluralization = hasPluralizetTransaltiosnMainText
    ? `consumablesForm.step.quantity_selection.button.text.${contentsType}.${quantityPluralization}`
    : `consumablesForm.step.quantity_selection.button.text.${contentsType}`;
  return (
    <I18n t={mainTextPluralization}>
      {quantity}
      {secondaryText && <span>{secondaryText}</span>}
    </I18n>
  );
};
